import {Button, DialogContent, Typography, useTheme} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React, {useState} from 'react';
import {useSteps} from 'presentation/pages/public/hooks';
import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';
import {LoginEnum} from 'main/analytics/gaTagsEnum';
import {DialogFinishedProps} from './types';
import {
	StyledMainStack,
	StyledTitle,
	StyledIconStack,
	StyledMiddleIconStack,
	StyledLastIconStack,
	StyledFooterStack,
	modalHeaderSx,
	dialogContentSx,
	LastDescription,
} from './styles';

const {
	confirmation,
	codeSendSuccess,
	modalDescription1,
	modalDescription2,
	modalDescription3,
	understood,
	needHelp,
} = translations['pt-br'].publicFlow.forgotPassword;

export function NeedHelpDialog({onClose}: DialogFinishedProps) {
	const [openState, setOpenState] = useState(true);
	const {colors} = useTheme();
	const {handleHelpStep} = useSteps(PublicFlowEnum.FORGOT_PASSWORD);

	const handleCloseModal = () => {
		if (onClose) {
			onClose();
		}
		setOpenState(false);
	};

	return (
		<Modal.Root open={openState} fullScreen={false}>
			<Modal.Header title={confirmation} sx={modalHeaderSx} onClose={handleCloseModal} />
			<DialogContent sx={dialogContentSx}>
				<StyledMainStack>
					<IconIllustration variant={'success'} />

					<StyledTitle variant="h6">{codeSendSuccess}</StyledTitle>
					<StyledIconStack>
						<Icon name="mail-filled" color={colors.gray['54Percent']} size={24} />
						<Typography variant="body1">{modalDescription1}</Typography>
					</StyledIconStack>
					<StyledMiddleIconStack>
						<Icon name="dialog-filled" color={colors.gray['54Percent']} size={24} />
						<Typography variant="body1">{modalDescription2}</Typography>
					</StyledMiddleIconStack>
					<StyledLastIconStack>
						<Icon name="clock-filled" color={colors.gray['54Percent']} size={24} />
						<LastDescription variant="body1">{modalDescription3}</LastDescription>
					</StyledLastIconStack>
				</StyledMainStack>
			</DialogContent>

			<Modal.Footer>
				<StyledFooterStack>
					<Button
						onClick={handleCloseModal}
						variant="contained"
						size="large"
						fullWidth
						data-tag-id={LoginEnum.CLICK_ENTENDI_ESQUECI_MINHA_SENHA}>
						{understood}
					</Button>
					<Button
						onClick={handleHelpStep}
						variant="outlined"
						size="large"
						fullWidth
						data-tag-id={LoginEnum.CLICK_PRECISO_DE_AJUDA_MODAL}>
						{needHelp}
					</Button>
				</StyledFooterStack>
			</Modal.Footer>
		</Modal.Root>
	);
}
